import { dateColumn, numberColumn, primaryRelationshipColumn, relationshipColumn } from "@api/schema/columnHelpers";
import { objectDefinition } from "@api/schema/supportedObjects";
import RapidReinvestmentSection from "./RapidReinvestmentSection";
import { forwardRef } from "react";

const relationshipType = 'business';
const {pluralName, color, endpoint} = objectDefinition(relationshipType);
const columns = [
    primaryRelationshipColumn({column: 'id', endpoint, required: true}),
    dateColumn({column: 'closed_date', label: 'Date Closed', required: true}),
];

const ClosedBusinesses = forwardRef(function ClosedBusinesses(props, ref) {
    return (
        <RapidReinvestmentSection
            type={relationshipType}
            columns={columns}
            {...props}
            ref={ref}
        />
    )
});

export {ClosedBusinesses};
